// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 789 ? "f3aef375" : chunkId) + "." + {"789":"fc3aafe31449f19f","3317":"e2f6f8498288a4ca"}[chunkId] + ".js";
};